import * as React from "react";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import MyWordsQuery from "./MyWordsQuery";
import { Box, Grid, Alert } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import Collapse from "@mui/material/Collapse";
import CloseIcon from "@mui/icons-material/Close";
import Accordion from "@mui/material/Accordion";
import Divider from "@mui/material/Divider";
import Skeleton from "@mui/material/Skeleton";
import Stack from "@mui/material/Stack";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  getDetalisListOfUserWordsApi,
  deleteWordApi,
  editWordApi,
} from "../../../../../services/userSaveWordApi";
import MyWordsList from "./MyWordsList";
import { checkResponseData, checkErrorMessage } from "../../../utils/utilsFunctions"
import Paper from '@mui/material/Paper';


export default function MyWords() {
  const [fetchedData, setFetchedData] = React.useState({
    data: { data: { docs: [] } },
  });
  const [queryGetDetalisListOfUserWordsData, setGetDetalisListOfUserWordsData] =
    React.useState({});
  const [pageAndPerPage, setPageAndPerPage] = React.useState({
    page: 1,
    perPage: 10,
    totalPages: 0,
    hasNextPage: false,
    hasPrevPage: false,
    totalDocs: 0,
    totalPages: 0,
  });
  const [controlAlert, setControlAlert] = React.useState({
    open: true,
    message: "لطفا فیلتر جستجوی بالا را پر کنید و روی جستجو کلیک کنید",
    severity: "warning",
    SkeletonDisplay: "none",
  });

  // کنترل شماره صفحه و تعداد در هر صفحه
  const setNumberPageAndPerPage = (type, number) => {
    let newValues = {};
    if (type == "page") newValues["page"] = number;
    if (type == "perPage") {
      newValues["perPage"] = number;
      newValues["page"] = 1;
    }
    const PageAndPerPageValue = { ...pageAndPerPage, ...newValues };
    setPageAndPerPage(PageAndPerPageValue);
    getUserWordsFromBack(
      "getDetalisListOfUserWords",
      queryGetDetalisListOfUserWordsData,
      PageAndPerPageValue
    );
  };

  const getUserWordsFromBack = async (request, data, paginateData = {}) => {
    setControlAlert({
      open: true,
      message: "لطفا منتظر بمانید",
      severity: "warning",
      SkeletonDisplay: "Block",
    });
    setFetchedData({ data: { data: { docs: [] } } });
    let paginate = { ...pageAndPerPage, ...paginateData };
    if (request == "getDetalisListOfUserWords") {
      // console.log("amssiramssiramssiramssir00", data);
      let received = await getDetalisListOfUserWordsApi(data, paginate);
      // console.log("amssiramssiramssiramssir", received);
      if (received.data.success) {
        // console.log(
        //   "amirreceivedreceivedreceived",
        //   received["data"]["data"]["docs"]
        // );
        setFetchedData(received);
        setControlAlert({
          open: true,
          message: "در خواست با موفقیت انجام شد:",
          severity: "warning",
          SkeletonDisplay: "none",
        });
        const { totalPages, hasNextPage, hasPrevPage, page, totalDocs } =
          received["data"]["data"];
        const newValues = {
          totalPages,
          hasNextPage,
          hasPrevPage,
          page,
          totalDocs,
        };
        setPageAndPerPage({
          ...pageAndPerPage,
          ...paginateData,
          ...newValues,
        });
      } else {
        setControlAlert({
          open: true,
          message: "مشکلی پیش آمده است",
          severity: "warning",
          SkeletonDisplay: "none",
        });
      }
    }
  };

  const deleteWordFromFromBack = async (data) => {
    const toastMsg = toast.loading("لطفا صبر کنید...")
    try {
      const response = await deleteWordApi(data)
      const resData = checkResponseData(response);
      if (resData["success"]) {
        toast.update(toastMsg, { render: resData["message"] || "درخواست انجام شد", type: "success", isLoading: false, autoClose: 3000 });
        setFetchedData({
          ...fetchedData,
          data: {
            data: {
              docs: fetchedData["data"]["data"]["docs"].filter(
                (item) => item._id !== data.wordId
              ),
            },
          },
        });
        setPageAndPerPage({
          ...pageAndPerPage,
          totalDocs: pageAndPerPage.totalDocs - 1,
        });
      } else {
        toast.update(toastMsg, { render: resData["message"] || "اتفاق غیر منتظره پیش آمده است", type: "info", isLoading: false, autoClose: 3000 });

      }
    } catch (error) {
      const errData = checkErrorMessage(error);
      let errMsg = errData["titles"] || errData["message"]
      toast.update(toastMsg, { render: errMsg || "مشکلی وجود دارد", type: "error", isLoading: false, autoClose: 3000 });
    }

  };

  const editWordInBack = async (data) => {
    const toastMsg = toast.loading("لطفا صبر کنید...")

    try {
      const response = await editWordApi(data)
      const resData = checkResponseData(response);
      if (resData["success"]) {
        toast.update(toastMsg, { render: resData["message"] || "درخواست انجام شد", type: "success", isLoading: false, autoClose: 3000 });
        setFetchedData({
          ...fetchedData,
          data: {
            data: {
              docs: fetchedData["data"]["data"]["docs"].map((item) => {
                if (item._id == data.saveWordId)
                  return response["data"]["data"]["data"][0];
                else return item;
              }),
            },
          },
        });
        setPageAndPerPage({
          ...pageAndPerPage,
          totalDocs: pageAndPerPage.totalDocs - 1,
        });
      } else {
        toast.update(toastMsg, { render: resData["message"] || "اتفاق غیر منتظره پیش آمده است", type: "info", isLoading: false, autoClose: 3000 });
      }
    } catch (error) {
      const errData = checkErrorMessage(error);
      let errMsg = errData["titles"] || errData["message"]
      toast.update(toastMsg, { render: errMsg || "مشکلی وجود دارد", type: "error", isLoading: false, autoClose: 3000 });
    }

  };

  return (
    <Grid container sx={{ height: "100vh" }}>
      <Box sx={{ width: "100%", px: 1 }}>
        <Paper sx={{ mt: 1, p: 0.5 }}>ابتدا فیلتر جستجوی پایین را پر کرده و بر روی جستجو کلیک کنید </Paper >
        <Accordion sx={{ mt: 1 }}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Typography>جستجوی لغات</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <MyWordsQuery
              setGetDetalisListOfUserWordsData={
                setGetDetalisListOfUserWordsData
              }
              getUserWordsFromBack={getUserWordsFromBack}
            />
          </AccordionDetails>
        </Accordion>
        <Divider />
        <Collapse in={controlAlert.open}>
          <Alert
            severity={controlAlert.severity}
            action={
              <IconButton
                aria-label="close"
                color="inherit"
                size="small"
                onClick={() => {
                  setControlAlert({
                    open: false,
                    message: "",
                    severity: "info",
                    SkeletonDisplay: "none",
                  });
                }}
              >
                <CloseIcon fontSize="inherit" />
              </IconButton>
            }
            sx={{ mb: 2 }}
          >
            {controlAlert.message}
          </Alert>
        </Collapse>
        <Stack sx={{ display: controlAlert.SkeletonDisplay }} spacing={1}>
          <Skeleton />
          <Skeleton animation="wave" />
          <Skeleton animation="wave" />
        </Stack>
        <MyWordsList
          fetchedData={fetchedData}
          pageAndPerPage={pageAndPerPage}
          setNumberPageAndPerPage={setNumberPageAndPerPage}
          deleteWordFromFromBack={deleteWordFromFromBack}
          editWordInBack={editWordInBack}
        />
      </Box>
      {/* <ToastContainer
        position="bottom-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={true}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      /> */}
    </Grid>
  );
}
